<div class="fv">
  <aside class="fv-list">
    <div class="fv-list-head">Flows <span class="fv-list-n">{{ flowsList().length }}</span></div>
    <button
      *ngFor="let f of flowsList(); trackBy: trackByFlow"
      type="button"
      class="fv-flow"
      [class.active]="f.flow_id === selectedFlowId()"
      (click)="selectFlow(f.flow_id)"
    >
      <span class="fv-flow-name">{{ f.name }}</span>
      <span class="fv-flow-sub">
        {{ stepCount(f) }} steps · {{ policyCountFor(f) }} policies
        <span class="fv-badge" [class.on]="f.review">{{ f.review ? 'approved' : 'pending' }}</span>
      </span>
    </button>
    <div class="fv-empty" *ngIf="!flowsList().length">No flows yet. Run a rebuild.</div>
  </aside>

  <div class="fv-main">
    <div class="fv-toolbar" *ngIf="selectedFlow() as f">
      <div class="fv-title">{{ f.name }}</div>
      <button
        type="button"
        class="fv-review-btn"
        [class.reject]="f.review"
        [class.approve]="!f.review"
        [disabled]="isPending(f.flow_id)"
        (click)="onToggleFlowReview()"
      >
        <span *ngIf="isPending(f.flow_id)" class="spinner" aria-hidden="true"></span>
        {{ f.review ? 'Reject flow' : 'Approve flow' }}
      </button>
    </div>

    <div class="fv-canvas-wrap">
      <div #flowCanvas class="fv-canvas"></div>
      <div class="fv-hint">drag · scroll to zoom · click a step</div>
    </div>

    <div class="fv-steppol">
      <ng-container *ngIf="selectedStepId(); else pickStep">
        <div class="fv-steppol-head">
          Policies governing <b>{{ selectedStepName() }}</b>
          <span class="fv-list-n">{{ stepPolicies().length }}</span>
        </div>
        <div class="fv-pol" *ngFor="let p of stepPolicies()">
          <span class="fv-pol-dot" [class.on]="p.review"></span>
          <div class="fv-pol-text">{{ p.statement }}</div>
        </div>
        <div class="fv-empty" *ngIf="!stepPolicies().length">No policies govern this step.</div>
      </ng-container>
      <ng-template #pickStep>
        <div class="fv-empty">Click a step in the diagram to see the policies that govern it.</div>
      </ng-template>
    </div>
  </div>
</div>
